
// Conversion factors to mm
const unitToMmConversionFactors = new Map<string, number>([
        ["mm", 1],
        ["cm", 10],    // 1cm = 10mm
        ["m", 1000],   // 1m = 1000mm
        ["in", 25.4],  // 1in = 25.4mm
    ]);

// Converts a string with value and unit to value in millimeters
// Throws if input unit is not supported
export const convertStringValueToMm = (value: string | null) : number | undefined => {
    
    if (!value)
        return undefined;
    
    // TODO: Replace convert with external library convert-units if needed
    // For now it is overkill, since we draw symbols ourselves and can control the unit used

    const match = value.match(/^([\d.]+)([a-zA-Z]+)$/);
    if (!match) return NaN;

    const [_, num, unit] = match;

    if (!unitToMmConversionFactors.has(unit))
    {
        console.error(`Not supported unit: ${unit} in ${value}`);
        return undefined;
    }

    return parseFloat(num) * unitToMmConversionFactors.get(unit)!;

};